/// <amd-module name="Wit/Common/Constants/CustomerInteligence" />
export const WITCustomerIntelligenceArea = "WIT";

export namespace WITCustomerIntelligenceFeature {
    export const RESULT_FILTER = "ResultFilter";
    export const NEW_BOARDS_PLATFORM = "NewBoardsHub";
    export const HIERARCHY_FILTER = "KeepHierarchyWithFilters";
    export const TEAM_AUTOMATION_RULES = "TeamAutomationRules";
}
